import Billing from "../common/Billing";

import NotificationSettings from "./NotificationSettings";
import Offer from "./Offer";
import User from "./User";
import UserSSO from "./UserSSO";
import UserSSOProvider from "./UserSSOProvider";

export enum UserProfession {
    Designer = "designer",
    Developer = "developer",
    ProductManager = "productManager",
    QualityAssurance = "qualityAssurance",
    Copywriter = "copywriter",
    Marketing = "marketing",
    Other = "other"
}

export enum DesignTool {
    Sketch = "sketch",
    Figma = "figma",
    AdobeXD = "adobeXD",
    AdobePhotoshop = "adobePhotoshop"
}

export default interface UserProfile extends User {
    status?: string;
    paymentPlan: string;
    emailNotifications?: boolean;
    billing?: Billing;
    notificationLastReadTime?: string;
    app?: {
        _id: string;
        name: string;
        secret: string;
    };
    intercomHash?: string;
    sso: UserSSO[];
    notificationSettings: NotificationSettings;
    profession?: UserProfession;
    designTool?: DesignTool;
    privacyPreferences?: {
        trackingOptOut: {
            value: boolean;
        };
    };
    currentSSOProvider?: UserSSOProvider;
    offers?: Offer[];
    anonymousUserId?: string;
    usedFreeTrial?: boolean;
}
